(ns heraldicon.frontend.header
  (:require
   [heraldicon.entity.user :as entity.user]
   [heraldicon.frontend.dark-mode :as dark-mode]
   [heraldicon.frontend.js-event :as js-event]
   [heraldicon.frontend.ko-fi :as ko-fi]
   [heraldicon.frontend.language :as language :refer [tr]]
   [heraldicon.frontend.router :as router]
   [heraldicon.frontend.tutorial :as tutorial]
   [heraldicon.frontend.user.form.login :as form.login]
   [heraldicon.frontend.user.form.register :as form.register]
   [heraldicon.frontend.user.session :as session]
   [re-frame.core :as rf]
   [reitit.frontend.easy :as reife]))

(def ^:private user-menu-open?-path
  [:ui :menu :user-menu :open?])

(rf/reg-sub ::menu-open?
  (fn [[_ path] _]
    (rf/subscribe [:get path]))

  (fn [open? _]
    open?))

(rf/reg-event-db ::toggle-menu-open?
  (fn [db [_ path]]
    (update-in db path not)))

(rf/reg-event-db ::clear-menu-open?
  (fn [db [_ path]]
    (assoc-in db path nil)))

(defn- menu-item [route name & {:keys [on-click
                                       highlight-active?]
                                :or {highlight-active? true}}]
  [:li.nav-menu-item {:class (when (and highlight-active?
                                        (router/active-section? route))
                               "selected")}
   [:a {:href (reife/href route nil nil)
        :on-click on-click} [tr name]]])

(defn view []
  (let [session @(rf/subscribe [::session/data])
        logged-in? @(rf/subscribe [::session/logged-in?])]
    [:div.header {:class (dark-mode/class)}
     [:div {:style {:flex "none"
                    :line-height "2em"
                    :padding-left "0.5em"
                    :padding-right "0.5em"
                    :white-space "nowrap"}}
      [:img {:src "/img/heraldicon-logo.png"
             :style {:height "1.8em"
                     :margin-right "0.6em"
                     :position "relative"
                     :transform "translate(0,0.4em)"}}]
      [:span {:style {:font-family "\"Trajan Pro\", sans-serif"
                      :font-size "1.2em"}}
       [:a {:href (reife/href :route.home/main nil nil)
            :style {:padding-right "5px"}} "Heraldicon"]]]
     [:div {:style {:flex "0.5 1 0"}}]
     [:ul.nav-menu {:data-tour "nav-menu"
                    :style {:flex 1}}
      [menu-item :route.home/main :string.menu/about]
      [:li.nav-menu-item {:data-tour "news"
                          :class (when (router/active-section? :route.news/main)
                                   "selected")}
       [:a {:href (reife/href :route.news/main nil nil)}
        [tr :string.menu/news]]]
      [:li.nav-menu-item {:data-tour "collection-library"
                          :class (when (router/active-section? :route.collection/list)
                                   "selected")}
       [:a {:href (reife/href :route.collection/list nil nil)}
        [tr :string.menu/collection-library]]]
      [:li.nav-menu-item {:data-tour "arms-library"
                          :class (when (router/active-section? :route.arms/list)
                                   "selected")}
       [:a {:href (reife/href :route.arms/list nil nil)}
        [tr :string.menu/arms-library]]]
      [:li.nav-menu-item {:data-tour "charge-library"
                          :class (when (router/active-section? :route.charge/list)
                                   "selected")}
       [:a {:href (reife/href :route.charge/list nil nil)}
        [tr :string.menu/charge-library]]]
      [:li.nav-menu-item {:data-tour "ribbon-library"
                          :class (when (router/active-section? :route.ribbon/list)
                                   "selected")}
       [:a {:href (reife/href :route.ribbon/list nil nil)}
        [tr :string.menu/ribbon-library]]]
      (when (entity.user/admin? session)
        [:<>
         [menu-item :route.user/list :string.menu/users]
         [menu-item :route.charge-types/main :string.menu/charge-types]])
      [menu-item :route.contact/main :string.menu/contact]]
     [:div {:style {:flex "1 1 1em"}}]
     [:ul.nav-menu.nav-menu-right
      [tutorial/selector]]
     [:ul.nav-menu.nav-menu-right
      [language/selector]]
     [:div {:style {:flex "0.3 1 0"}}]
     [:div.nav-menu-no-hover {:style {:display "flex"
                                      :align-items "center"
                                      :gap "0.2em"
                                      :padding "0 0.3em"
                                      :line-height "2.5em"}}
      [ko-fi/small-button :extra-attrs {:data-tour "ko-fi" :style {:padding "4px"}}]
      [:a {:data-tour "atom-feed"
           :href "/atom.xml"
           :target "_blank"
           :title "Atom Feed"
           :style {:padding "4px"
                   :display "flex"
                   :align-items "center"}}
       [:i.fas.fa-rss-square]]
      [dark-mode/selector]]
     [:div {:style {:flex "0.3 1 0"}}]
     [:ul.nav-menu.nav-menu-right
      (if logged-in?
        [:li.nav-menu-item.nav-menu-has-children.nav-menu-allow-hover
         {:data-tour "user-menu"
          :on-mouse-leave #(rf/dispatch [::clear-menu-open? user-menu-open?-path])}
         [:<>
          [:a.nav-menu-link {:style {:min-width "6em"}
                             :href "#"
                             :on-click (js-event/handled #(rf/dispatch [::toggle-menu-open? user-menu-open?-path]))}
           (str "@" (:username session))]
          [:ul.nav-menu.nav-menu-children
           {:style {:display (if @(rf/subscribe [::menu-open?
                                                 user-menu-open?-path])
                               "block"
                               "none")}}
           [menu-item :route.account/main :string.menu/account
            :on-click #(rf/dispatch [::clear-menu-open? user-menu-open?-path])
            :highlight-active? false]
           [:li.nav-menu-item
            [:a.nav-menu-link {:href "#"
                               :on-click (js-event/handled
                                          #(do (rf/dispatch [::clear-menu-open? user-menu-open?-path])
                                               (rf/dispatch [::session/logout])))}
             [tr :string.menu/logout]]]]]]
        [:<>
         [:li.nav-menu-item {:data-tour "login-register"}
          [:a.nav-menu-link {:href "#"
                             :on-click (js-event/handled #(rf/dispatch [::form.login/show]))}
           [tr :string.menu/login]]]
         [:li.nav-menu-item
          [:a.nav-menu-link {:href "#"
                             :on-click (js-event/handled #(rf/dispatch [::form.register/show]))}
           [tr :string.menu/register]]]])]]))
